import { Spinner as TMSpinner, styled } from 'tamagui';

export const Spinner = styled(TMSpinner, {
  color: '$unistocks'
});
